/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import IconButton from "../../common/IconButton";
import Body from "../../components/Body";
import DetailBlock from "../../common/DetailBlock";
import LabelText from "../../common/LabelText";
import numberFormat from "../../common/numberFormat";
import addPrecision from "../../common/addPrecision";
import api from "../../config/api";
import moment from "moment";
import AppButton from "../../common/AppButton";
import AppModal from "../../common/AppModal";
import SimpleExpansionPanel from "../../common/SimpleExpansionPanel";
import Table from "../../common/Table";
import useJob from "../../hooks/useJob";
import useTasks from "../../hooks/useTasks";
import SimpleAssignTask from "../../components/SimpleAssignTask";
import ReceivePaymentModel from "./ReceivePaymentModel";
import MultipleTaskAssignModel from "../../components/MultipleTaskAssignModel";
import { AiOutlinePlus } from "react-icons/ai";
import { FaFileAlt } from "react-icons/fa";
import { VscLoading } from "react-icons/vsc";
import { BiCheckCircle } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { cloneDeep } from "lodash";
import { useQuery } from "@tanstack/react-query";
import { getOrganizationByid } from "../../stores/OrganizationStore";
import { getLocations } from "../../stores/LocationStore";
import { getPosGroupedByJob } from "../../stores/PoStore";
import { getJobByid, getJobScheduleDetails } from "../../stores/JobStore";
import { toast } from "react-toastify";
import { getPayments } from "../../stores/PaymentStore";
import { mapJobCompletionReportData } from "../../utility/jobCompletionReportMapper";
import { HiDocumentReport } from "react-icons/hi";

const paymentHeader = [
  { title: "Date", name: "date" },
  { title: "Amount", name: "amount" },
  { title: "Cheque Number", name: "chequeNumber" },
];

export default function JobsView() {
  const { job: jobParam, organization_id } = useParams();

  const { state, pathname } = useLocation();

  const [init, setData] = useState({
    ...state?.data,
  });
  const navigate = useNavigate();

  const [loading, setLoading] = useState({
    po: true,
  });
  const [isPreparingJobReport, setIsPreparingJobReport] = useState(false);
  const [employees, setEmployees] = useState();
  const [jobTasks, setTasks] = useState([]);
  const job = useJob();
  const tasks = useTasks();
  const [model, setModel] = useState({
    model: "",
    visible: false,
  });

  const { data: organization } = useQuery({
    queryFn: () => getOrganizationByid(init.organization),
    queryKey: ["organizations", init.organization],
  });

  const { data: locations } = useQuery({
    queryFn: () => getLocations(),
    queryKey: ["locations"],
  });

  const { data: posGroupByJob } = useQuery({
    queryFn: () => getPosGroupedByJob(),
    queryKey: ["pos", "groupByJob"],
  });

  const { data: jobres } = useQuery({
    queryFn: () => getJobByid(jobParam),
    queryKey: ["jobs", jobParam],
  });

  const { data: payments } = useQuery({
    queryFn: () => getPayments({ job: jobParam }),
    queryKey: ["jobPayments", jobParam],
  });

  const { data: scheduleDetails, isLoading: isScheduleLoading } = useQuery({
    queryFn: () => getJobScheduleDetails(jobParam),
    queryKey: ["scheduleDetails", jobParam],
  });

  const handleRecievePO = () => {
    const po = posGroupByJob?.[jobParam];

    if (!po) {
      return navigate(
        `/organizations/view/${organization_id}/jobs/${jobParam}/receivePO`,
        { state: { data: cloneDeep(init) } },
      );
    }

    if (po[po.length - 1]?.files) {
      if (po[po.length - 1]?.files.length > 0)
        for (const item of init.po[init.po.length - 1].files) {
          window.open(item, "_blank");
        }
    } else {
      navigate(
        `/organizations/view/${organization_id}/jobs/${jobParam}/receivePO`,
        {
          state: { data: cloneDeep(init) },
        },
      );
    }
  };

  const handleJobReport = async () => {
    if (!jobParam) {
      toast.error("Invalid job id.");
      return;
    }

    if (isScheduleLoading) {
      toast.info("Still loading job details, please wait...");
      return;
    }

    if (!scheduleDetails || !scheduleDetails.schedules) {
      toast.error("Job schedule data is not available yet.");
      return;
    }

    try {
      setIsPreparingJobReport(true);

      const taskDetails = Object.values(scheduleDetails.schedules)
        .flatMap((dateBucket) => Object.values(dateBucket))
        .flatMap((employeeBucket) => employeeBucket.tasks || [])
        .map((task) => ({
          ...task,
          // The mapper expects the date to be present on the task object
          date: task.checkInTime || task.startTime,
        }));

      if (taskDetails.length === 0) {
        toast.error(
          "Task details could not be loaded for this job. Please try again."
        );
        return;
      }

      const reportData = mapJobCompletionReportData(
        scheduleDetails,
        taskDetails
      );

      navigate(`${pathname}/completionReportPdf`, {
        state: { reportData },
      });
    } catch (error) {
      console.error("Job report generation failed:", error);
      toast.error(
        "Failed to generate job completion report. Please try again."
      );
    } finally {
      setIsPreparingJobReport(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    loadTasks();
    loadPo();
  };

  const loadTasks = async () => {
    const res = await api.get("tasks", {
      job: jobParam,
      organization: init.organization,
    });
    if (res.ok) {
      setTasks(res?.data);
    }
  };

  const loadPo = async () => {
    const res = await api.get("po", {
      organization: organization_id,
      job: jobParam,
    });

    setData({ ...init, po: res.data[res.data.length - 1], ...jobres });
    setLoading({ ...loading, po: false });
  };

  const handleRequest = () => {
    navigate(`${pathname}/request`, {
      state: {
        data: cloneDeep({
          ...init,
          organizationName: organization?.name,
          location: state.data?.location?.map((i) => {
            const found = locations?.find(
              (item) => item._id === i._id || item._id === i,
            );
            return found;
          }),
        }),
      },
    });
  };
  const handleInvoice = () => {
    if (init.po || init.noPo) {
      const pos = posGroupByJob?.[jobParam];

      if (init.invoiceCreated) {
        return navigate(`${pathname}/invoiceToPdf`, {
          state: {
            data: cloneDeep({
              ...init,
              organizationName: organization?.name,
              location: state.data?.location?.map((i) => {
                const found = locations?.find(
                  (item) => item._id === i._id || item._id === i,
                );
                return found;
              }),
              poNo: pos ? pos[pos.length - 1]?.poNo : undefined,
            }),
          },
        });
      }

      setData({ ...init, invoiceCreated: true });

      navigate(`${pathname}/invoice`, {
        state: {
          data: {
            ...init,
            invoiceCreated: true,
            poNo: init.po?.poNo,
          },
        },
      });
    } else {
      toast.error("PO Not Received Yet");
    }
  };

  const jobx = { ...init, payments, jobTasks };
  const balance = job.invoiceBalance({ job: jobx });
  const paymentStatus = job.paymentStatus({ job: jobx });
  const jobStatus = job.jobStatus({ job: jobx });

  const ReceivePayment = ReceivePaymentModel();
  // const QuickSchedule = QuickScheduleModel();

  const table = document.querySelector(".x-table");
  if (table) {
    table.classList.remove("app-table");
    table.classList.add("table-bordered");
  }

  const MultiSchedule = MultipleTaskAssignModel();
  const handleWeekly = ({ dates }) => {
    console.log(dates);
    setModel({
      model: (
        <MultiSchedule.Body
          dates={dates}
          onDone={() => {
            load();
            setModel({});
          }}
        />
      ),
      visible: true,
    });
  };

  return (
    <Body title={` ${init.jobId} | ${organization?.name}`}>
      <div className="d-flex" style={{ flexDirection: "column" }}>
        <DetailBlock
          style={{ width: 1000 }}
          title="Process"
          right={
            <AppButton
              onClick={() => {
                navigate(pathname + "/edit", { state: { data: init } });
              }}
              text="Edit"
              className="text-primary"
            />
          }
        >
          <div
            className="d-flex"
            style={{ justifyContent: "space-around", padding: 40 }}
          >
            <IconButton
              icon={<FaFileAlt size={70} />}
              text="Request"
              vertical
              textStyle={{ textAlign: "center" }}
              onClick={handleRequest}
            />
            {!init.noPo && (
              <IconButton
                icon={
                  init.po ? (
                    <FaFileAlt size={70} />
                  ) : (
                    <VscLoading size={70} opacity={0.5} />
                  )
                }
                text={init.po ? "PO" : "Receive PO"}
                textStyle={{ textAlign: "center" }}
                vertical
                onClick={handleRecievePO}
                loading={loading.po}
              />
            )}
            <IconButton
              icon={
                init.invoiceCreated && init.noPo ? (
                  <FaFileAlt size={70} />
                ) : (
                  <VscLoading size={70} opacity={0.1} />
                )
              }
              text={
                init.invoiceCreated && init.noPo
                  ? "Invoice"
                  : "Generate Invoice"
              }
              textStyle={{ textAlign: "center" }}
              vertical
              onClick={handleInvoice}
            />
            <IconButton
              icon={
                isPreparingJobReport ? (
                  <VscLoading size={70} className="animate-spin" />
                ) : (
                  <HiDocumentReport size={70} />
                )
              }
              text="Completion Report"
              textStyle={{ textAlign: "center" }}
              vertical
              onClick={handleJobReport}
              loading={isPreparingJobReport}
              disabled={isPreparingJobReport}
            />
          </div>
        </DetailBlock>

        <DetailBlock style={{ width: 1000, padding: 40 }}>
          <div
            className="d-flex"
            style={{ justifyContent: "space-around", padding: 40 }}
          >
            <LabelText
              columnMode
              label="Issued date"
              value={moment(init.jobStartDate).format("DD/MM/YYYY")}
            />
            <LabelText
              columnMode
              label="Start date"
              value={moment(init.jobStartDate).format("DD/MM/YYYY")}
            />
            <LabelText
              columnMode
              label="End date"
              value={moment(init.jobEndDate).format("DD/MM/YYYY")}
            />
            <LabelText columnMode label="Status" value={jobStatus} />
          </div>
        </DetailBlock>

        <div style={{ marginTop: 30 }}>
          <DetailBlock
            style={{ width: 1000 }}
            title="Payment details"
            right={
              paymentStatus !== "Completed" && (
                <AppButton
                  onClick={() => {
                    setModel({
                      visible: true,

                      model: (
                        <ReceivePayment.Body
                          job={jobx}
                          payments={jobx.payments}
                          onSuccess={() => {
                            load();
                            setModel({});
                          }}
                        />
                      ),
                    });
                  }}
                  className="text-info"
                  text="Receive Payment"
                />
              )
            }
          >
            <div
              className="d-flex"
              style={{ justifyContent: "space-around", padding: 40 }}
            >
              <LabelText
                columnMode
                label="Total"
                value={`$ ${addPrecision(numberFormat(init.total))}`}
              />
              <LabelText
                columnMode
                label="Balance"
                value={`$ ${addPrecision(balance)}`}
              />
              <LabelText
                columnMode
                label="Status"
                value={
                  <span
                    className="d-flex"
                    style={{ alignItems: "center", gap: 5 }}
                  >
                    {paymentStatus === "Completed" && (
                      <BiCheckCircle size={20} color={"green"} />
                    )}
                    {paymentStatus}
                  </span>
                }
              />
            </div>
            {payments && (
              <SimpleExpansionPanel
                leftTitle={payments?.length > 0 && "Payments log"}
                accorditionStyle={{ boxShadow: "none" }}
                children={
                  payments?.length > 0 && (
                    <Table
                      normalTable
                      tableClass="no-borders"
                      header={paymentHeader}
                      data={payments.map((i) => {
                        return {
                          ...i,
                          date: moment(i.date).format("DD/MM/YYYY"),
                          amount: `$ ${addPrecision(i.amount)}`,
                        };
                      })}
                    />
                  )
                }
              />
            )}
          </DetailBlock>
        </div>
        <div style={{ marginTop: 30, marginBottom: 30, width: 1000 }}>
          {/* 
          <DetailBlock style={{ width: 1000 }} title="Tasks">
            <div
              className="d-flex"
              style={{ flexDirection: "column", gap: "10px" }}
            >
              <br />
              {jobTasks &&
                tasks.findWeeks({ job: jobx })?.map((dt, ind) => {
                  const dates = tasks?.findDays({
                    from: dt.from,
                    to: dt.to,
                    jobTasks,
                    job: jobx,
                  });

                  const tasksx = jobTasks.filter((i) => {
                    const dtx = moment(i.date).toDate();
                    return (
                      dtx >= moment(dt.from).toDate() &&
                      dtx <= moment(dt.to).toDate()
                    );
                  });
                  const range = `${moment(dt.from).format(
                    "MMMM DD",
                  )} - ${moment(dt.to).format("MMMM DD")}`;
                  if (dates) {
                    return (
                      <SimpleExpansionPanel
                        accorditionStyle={{ width: 1000 }}
                        key={String(ind)}
                        leftTitle={range}
                        leftTitleStyle={{ maxWidth: 400 }}
                        rightTitle={
                          <AppButton
                            onClick={() => handleWeekly({ dates, range })}
                            leftIcon={<AiOutlinePlus />}
                            className="text-info "
                          />
                        }
                        rightTitleStyle={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                        children={
                          <SimpleAssignTask
                            refresh={load}
                            employees={employees}
                            tasks={tasksx}
                          />
                        }
                      />
                    );
                  }
                  return false;
                })}
            </div>
          </DetailBlock>
          */}
        </div>
      </div>

      <AppModal
        onHide={() => {
          setModel({});
        }}
        {...model}
      />
    </Body>
  );
}
